import { PaymentCardCommonFormComponent } from 'features/payment-form/card-base-form/card-base-form.component';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentFormService } from '../payment-form.service';
import { PAYMENT_TYPES } from 'services/payment/payment.interface';

@Component({
  selector: 'cm-payflow-form',
  templateUrl: '../card-base-form/card-base-form.component.html',
  styleUrls: ['../card-base-form/card-base-form.component.scss'],
  standalone: false,
})
export class PayflowFormComponent extends PaymentCardCommonFormComponent {
  @Input() showError = false;
  @Output() formChange = new EventEmitter<any>();

  paymentType = PAYMENT_TYPES.PAYFLOW_PRO;

  constructor(paymentService: PaymentFormService) {
    super(paymentService);
  }
}
